module.exports = __webpack_public_path__ + "img/loading.14a0936b.gif";